/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { useLocale } from "@epic-mw/i18n";

import { CosmosEnumTimeZone, CosmosEnumTimeAndDateFormat } from "@cosmos/hygraph-schema";
import { hygraphDateToLocaleDateString } from "@components/utils";
import { cx } from "@panda/css";

import { CosmosText } from "../text/CosmosText.atom";

export interface CosmosDateProps {
	date?: string | null;
	endDate?: string | null;
	className?: string;
	timeAndDateFormat?: CosmosEnumTimeAndDateFormat | null;
	timeZone?: CosmosEnumTimeZone | null;
}

export const CosmosDate = ({
	className,
	date,
	endDate,
	timeAndDateFormat,
	timeZone,
}: CosmosDateProps): React.JSX.Element => {
	const locale = useLocale();

	return (
		<CosmosText
			className={cx("cosmos-date", className)}
			variant="uiMD"
			text={hygraphDateToLocaleDateString(date, endDate, locale, timeAndDateFormat, timeZone)}
		/>
	);
};
